import type { LinkProps } from "@chakra-ui/next-js";
import { Badge, HStack, Text } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import {
  BudgetItemTypeEnum,
  type ExpenseBudgetItemTypeEnum,
} from "@src/__generated__/graphql";
import type { OutgoingInvoiceItemsTableItem } from "@src/components/modules/invoices/outgoing/invoice-items/store";
import { type IOption, Link } from "@src/components/ui-kit";
import type { Route } from "nextjs-routes";

type OptionsToLinksProps = {
  options: IOption[];
  pathname: Route["pathname"];
  color?: LinkProps["color"];
};
export const OptionsToLinks = ({
  options,
  pathname,
  color,
}: OptionsToLinksProps) => {
  return options.map((option, index) => (
    <Link
      key={`option-${option.value}`}
      color={color}
      href={{ pathname, query: { id: option.value } }}
    >
      {index !== 0 && <>,&nbsp;</>}
      {option.label}
    </Link>
  ));
};

type BudgetItemColumnProps = {
  budgetItem: OutgoingInvoiceItemsTableItem["budgetItem"];
  budgetItemType: BudgetItemTypeEnum | ExpenseBudgetItemTypeEnum;
};
export const BudgetItemColumn = ({
  budgetItem,
  budgetItemType,
}: BudgetItemColumnProps) => {
  const title = budgetItem?.title;
  const isExpense = budgetItemType === BudgetItemTypeEnum.ExpenseBudgetItem;

  return (
    <HStack spacing="2">
      <Text>{title}</Text>
      <Badge colorScheme={isExpense ? "orange" : "blue"} size="sm">
        {isExpense ? <Trans>Expense</Trans> : <Trans>Work</Trans>}
      </Badge>
    </HStack>
  );
};
